export default __webpack_public_path__ + "static/media/teeth.0176cca9.png";